import { Progress as AntdProgress, ProgressProps } from 'antd';

import styled, { StyledProp } from '@/styled';

const Progress = (props: StyledProp & ProgressProps) => {
  return <AntdProgress {...props} />;
};

export default styled(Progress)`
  .ant-progress-inner {
    background-color: ${({ theme }) => theme.palette.gray[8]};
  }
  .ant-progress-bg,
  .ant-progress-circle-path {
    background-color: ${({ theme }) => theme.colorPrimary} !important;
    stroke: ${({ theme }) => theme.colorPrimary} !important;
  }

  .ant-progress-circle-trail {
    stroke: ${({ theme }) => theme.palette.gray[8]} !important;
  }
`;
